// Returns { html, gone }. gone is true only when the store answered with an
// empty tile, which is what a deleted or unpublished product gives. A network
// or server error is not proof the product is gone, so it never sets gone.
const fetchProductTile = async (productUrl) => {
  const sectionUrl = `${productUrl}?section_id=recently-viewed-tile`;
  try {
    const response = await fetch(sectionUrl);
    if (!response.ok) return { html: '', gone: false };
    const text = await response.text();
    const item = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-recently-viewed-tile');
    const html = item ? item.innerHTML.trim() : '';
    return { html, gone: !!item && !html };
  } catch (error) {
    console.error('Error fetching product details:', error);
    return { html: '', gone: false };
  }
};

// Drop products that no longer exist from the saved history, so they stop
// taking up its slots. Re-reads storage in case another tab changed it.
const removeGoneProducts = (goneUrls) => {
  if (!goneUrls.length) return;
  try {
    const current = JSON.parse(localStorage.getItem('recently_viewed_items') || '[]');
    const kept = current.filter((item) => !goneUrls.includes(item.productUrl));
    localStorage.setItem('recently_viewed_items', JSON.stringify(kept));
  } catch (error) {
    console.error('Error updating recently viewed items:', error);
  }
};

const getRecentlyViewedPdpPlp = async () => {
  const section = document.querySelector('.section-recently-viewed-pdp-plp');
  const storedData = localStorage.getItem('recently_viewed_items');
  const pdpData = storedData ? JSON.parse(storedData) : [];

  // In the theme editor keep the section on the page, or it cannot be selected or edited.
  const removeSection = () => {
    if (window.Shopify && Shopify.designMode) section?.classList.add('loaded');
    else section?.remove();
  };

  if (!pdpData.length) {
    removeSection();
    return;
  }

  const results = await Promise.all(pdpData.map((item) => fetchProductTile(item.productUrl)));
  removeGoneProducts(pdpData.filter((item, index) => results[index].gone).map((item) => item.productUrl));
  const tiles = results.map((result) => result.html).filter(Boolean);
  const productListContainer = document.querySelector('.recently-viewed-pdp-plp__track');
  if (!tiles.length || !productListContainer) {
    removeSection();
    return;
  }

  productListContainer.innerHTML = tiles.reverse().join('');

  // doorway-carousel.js set the carousel up before the tiles existed; have it do so again.
  const root = productListContainer.closest('[data-doorway-carousel]');
  if (root) root.dispatchEvent(new CustomEvent('doorway:refresh', { bubbles: true }));
  section.classList.add('loaded');
};
document.addEventListener('DOMContentLoaded', () => getRecentlyViewedPdpPlp());

// The editor re-renders the section, with an empty track, after each setting change.
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.recently-viewed-pdp-plp__track')) getRecentlyViewedPdpPlp();
});
